import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCallRecordOpenItemTable extends Layout {
    sourceCallRecOpenItem: DataSource;
    tableCallRecOpenItem: Table;
}
